import {
  Paper,
  Grid,
  Typography,
  Box,
  Avatar,
  ListItemButton,
  useMediaQuery,
  Skeleton,
  useTheme,
  List,
  Card,
  CardContent,
  Stack,
  Tooltip,
  Breadcrumbs,
  Toolbar,
  Divider,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { userSelector } from "../../Components/user-redux/selector";
import { useDispatch, useSelector } from "react-redux";
import { appSelector } from "../../Components/redux/selector";
import { getRecruiterInterestedCandidatesAction } from "../../Components/redux/action";
import { BusinessCenterRounded } from "@mui/icons-material";
import InterestedCandidateJobs from "./InterestedCandidateJobs";
import JobDetails from "./JobDetails";
import InterestedJobsRecruiterDetails from "./InterestedJobRecruiterDetails";
const Interestcandidates = () => {
  const { user } = useSelector(userSelector);
  const { recruiterInterestedCandidates, selectedJob } =
    useSelector(appSelector);
  const [selectedItem, setSelectedItem] = useState(0);
  const [jobIds, setJobIds] = useState();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isDesktopXS = useMediaQuery(
    "(min-width: 992px) and (max-width: 1199px)"
  );
  const isDesktopLarge = useMediaQuery(theme.breakpoints.up("lg"));
  const isDesktopSmall = useMediaQuery(
    "(min-width: 1200px) and (max-width: 1439px)"
  );
  const isDesktopMedium = useMediaQuery(
    "(min-width: 1440px) and (max-width: 1919px)"
  );

  useEffect(() => {
    // fetchData();
    const fetch = async () => {
      const data = {
        userId: user?.id,
      };
      const response = await dispatch(
        getRecruiterInterestedCandidatesAction(data)
      );
      await fetchJobs(response?.results[0]?.job_ids);
    };
    fetch();
  }, []);
  const fetchJobs = async (jobIds) => {
    await setJobIds(
      `(${jobIds
        ?.split(",")
        .map((id) => `"${id}"`)
        .join(" OR ")})`
    );
  };

  const handleListItemClick = (index, candidate) => {
    setSelectedItem(index);
    //setSelectedJob(job);
    fetchJobs(candidate?.job_ids);
    // getJobs()
  };
  const topBarStyles = {
    padding: "10px",
    borderRadius: "4px",
    margin: "5px 5px 5px 5px",
    border: "none",
  };

  return (
    <Box
      sx={{
        border: "1px solid lightgray",
        borderRadius: "5px",
        width: "100%",
        height: "100%",
      }}
    >
      <Grid container spacing={1} sx={{ height: "calc(100% - 48px)" }}>
        <Grid xs={12}>
          <Paper elevation={2} sx={topBarStyles}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              {/* <Typography variant="body1" >
                Interested Candidates
              </Typography> */}
              <Box sx={{ flexGrow: 1 }} />

              <Box sx={{ display: selectedJob ? "block" : "none" }}>
                <Breadcrumbs separator="-" aria-label="breadcrumb">
                  <p
                    style={{
                      margin: 0,
                      fontWeight: 600,
                      fontSize: "1.0rem",
                    }}
                  >
                    #{selectedJob?.id}
                  </p>
                  <p
                    style={{
                      margin: 0,
                      fontWeight: 600,
                      fontSize: "1.0rem",
                    }}
                  >
                    {selectedJob?.jobtitle}
                  </p>

                  <p
                    style={{
                      margin: 0,
                      fontWeight: 600,
                      fontSize: "1.0rem",
                    }}
                  >
                    {selectedJob?.location !== null
                      ? selectedJob?.location
                      : "Remote"}
                  </p>
                </Breadcrumbs>
              </Box>

              <Box sx={{ flexGrow: 1 }} />
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={2.4}>
          <Paper elevation={2} sx={{ height: "96vh", overflow: "scroll" }}>
            <Box>
              <Toolbar
                sx={{
                  minHeight: "48px !important",
                  position: "sticky",
                  top: 0,
                  zIndex: 3,
                  bgcolor: "#fff",
                }}
              >
                <Typography>Interested Candidates</Typography>
              </Toolbar>
              <Divider />
            </Box>

            {recruiterInterestedCandidates?.length > 0 &&
              recruiterInterestedCandidates.map((candidate, index) => (
                <ListItemButton
                  key={index}
                  selected={index === selectedItem}
                  onClick={() => handleListItemClick(index, candidate)}
                  sx={{
                    ".hide-icons": {
                      display: "none",
                    },
                    "&:hover": {
                      ".hide-icons": {
                        display: "block",
                      },
                    },
                    padding: isDesktopLarge
                      ? "10px 20px"
                      : isDesktopMedium
                      ? "8px 16px"
                      : isDesktopSmall
                      ? "6px 12px"
                      : "6px 12px",
                  }}
                >
                  <div style={{ display: "flex", gap: 10, width: "100%" }}>
                    <Avatar
                      sx={{
                        height: isDesktopLarge
                          ? "40px"
                          : isDesktopMedium
                          ? "35px"
                          : isDesktopSmall
                          ? "32px"
                          : "28px",
                        width: isDesktopLarge
                          ? "40px"
                          : isDesktopMedium
                          ? "35px"
                          : isDesktopSmall
                          ? "32px"
                          : "28px",
                      }}
                    >
                      <BusinessCenterRounded
                        sx={{
                          color: "#fff",
                          height: isDesktopLarge
                            ? "24px"
                            : isDesktopMedium
                            ? "20px"
                            : isDesktopSmall
                            ? "16px"
                            : "14px",
                          width: isDesktopLarge
                            ? "24px"
                            : isDesktopMedium
                            ? "22px"
                            : isDesktopSmall
                            ? "18px"
                            : "16px",
                        }}
                      />
                    </Avatar>
                    <Box
                      sx={{
                        display: "flex",
                        gap: 2,
                        justifyContent: "space-between",
                        width: "100%",
                        alignItems: "center",
                      }}
                    >
                      <Stack direction="column">
                        <Typography
                          sx={{
                            fontSize: isDesktopXS ? "10px" : "12px",
                            fontWeight: 600,
                            margin: 0,
                            width: isDesktopLarge
                              ? "200px"
                              : isDesktopMedium
                              ? "150px"
                              : isDesktopSmall
                              ? "100px"
                              : "80px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {candidate.candidate_name}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: isDesktopXS ? "9px" : "11px",
                            margin: 0,
                          }}
                        >
                          {candidate.role}
                        </Typography>
                      </Stack>
                    </Box>
                  </div>
                </ListItemButton>
              ))}
          </Paper>
        </Grid>

        <Grid item xs={2.8}>
          <Paper elevation={2} style={{ height: "96vh", overflow: "scroll" }}>
            <Box>
              <Toolbar
                sx={{
                  minHeight: "48px !important",
                  position: "sticky",
                  top: 0,
                  zIndex: 3,
                  bgcolor: "#fff",
                }}
              >
                <Typography>Jobs</Typography>
              </Toolbar>
              <Divider />
            </Box>
            <InterestedCandidateJobs
              jobIds={jobIds}
              handleListItemClick={handleListItemClick}
            />
          </Paper>
        </Grid>

        <Grid item xs={4.4}>
          <Paper elevation={2} style={{ height: "96vh" }}>
            <Box>
              <Toolbar
                sx={{
                  minHeight: "48px !important",
                  position: "sticky",
                  top: 0,
                  zIndex: 3,
                  bgcolor: "#fff",
                }}
              >
                <Typography>Job Details</Typography>
              </Toolbar>
              <Divider />
            </Box>
            <JobDetails />
          </Paper>
        </Grid>
        <Grid item xs={2.4}>
          <Paper elevation={2}>
            <Box>
              <Toolbar
                sx={{
                  minHeight: "48px !important",
                  position: "sticky",
                  top: 0,
                  zIndex: 3,
                  bgcolor: "#fff",
                }}
              >
                <Typography>Recruiter Details</Typography>
              </Toolbar>
              <Divider />
            </Box>
            <InterestedJobsRecruiterDetails />
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Interestcandidates;
